import { createContext, useContext, useState, useCallback } from "react";
import type { ReactNode } from "react";

const LS_KEY = "cookbook_show_nutrition";

interface NutritionToggleContextValue {
  showNutrition: boolean;
  toggleNutrition: () => void;
}

const NutritionToggleContext = createContext<NutritionToggleContextValue>({
  showNutrition: false,
  toggleNutrition: () => {},
});

export function NutritionToggleProvider({ children }: { children: ReactNode }) {
  const [showNutrition, setShowNutrition] = useState<boolean>(() => {
    try {
      return localStorage.getItem(LS_KEY) === "true";
    } catch {
      return false;
    }
  });

  const toggleNutrition = useCallback(() => {
    setShowNutrition((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(LS_KEY, String(next));
      } catch {}
      return next;
    });
  }, []);

  return (
    <NutritionToggleContext.Provider value={{ showNutrition, toggleNutrition }}>
      {children}
    </NutritionToggleContext.Provider>
  );
}

export function useNutritionToggle() {
  return useContext(NutritionToggleContext);
}
